// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__Yf_ST","itemTitle":"ClientEmergencyInfo_itemTitle__3ZP01","itemText":"ClientEmergencyInfo_itemText__20H-q"};